import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { AcknowledgeModal, Anchor, Modal, Text } from '@percent/lemonade'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import styles from './GfmInterestConfirmationModal.module.scss'

type GfmInterestConfirmationModalProps = {
  open: boolean
  onClose: () => void
  isGoodstack?: boolean
}

export function GfmInterestConfirmationModal({
  open,
  onClose,
  isGoodstack = false
}: Readonly<GfmInterestConfirmationModalProps>) {
  const { t } = useTranslation()

  const descriptionKey = isGoodstack
    ? 'dialog.gfmInterestConfirmation.descriptionGoodstack'
    : 'dialog.gfmInterestConfirmation.description'

  return (
    <Modal open={open} onClose={onClose}>
      <div className={isGoodstack ? styles.confirmationDefault : styles.confirmation}>
        <AcknowledgeModal
          result="positive"
          title={t('dialog.gfmInterestConfirmation.title')}
          buttonText={t('button.done')}
          handleClose={onClose}
          viewTestId="gfm-interest-confirmation-modal"
          buttonTestId="gfm-interest-confirmation-done"
        >
          <Text size="small">
            <Trans
              i18nKey={descriptionKey}
              components={{
                a: (
                  <Anchor
                    component={Link}
                    to={RoutePath.MY_ACCOUNT}
                    c="var(--semantic-interactive-default)"
                    underline="always"
                    fz="inherit"
                    lh="inherit"
                  />
                )
              }}
            />
          </Text>
        </AcknowledgeModal>
      </div>
    </Modal>
  )
}
